export default __webpack_public_path__ + "static/002-2149e375f1a97a45161e34cd5515fba9.png";